/**
 * @format
 * @module utils/load-non-critical-css
 */
import { validStatus, handleText } from "utils/fetch";
import tgamConfig from "config/tgam";
import crow from "utils/crow";

let counter = 1; // human index

/**
 * Will load a CSS file via the filePath href value
 * @param {String} filePath - to load
 * @param {String} [name] - style tag's id value
 * @returns {Promise}
 */
export default function loadNonCriticalCSS(filePath, name) {
  return fetch(`${filePath}?_=${tgamConfig.env.cacheToken}`)
    .then(validStatus)
    .then(handleText)
    .then(html => {
      const style = window.document.createElement("style");
      const ref = window.document.getElementsByTagName("head")[0];
      style.id = name || `tgam-non-critical-css-${counter++}`;
      style.innerHTML = html;
      ref.appendChild(style);
    })
    .catch(() => {
      crow.message(`Failed to load non-critical CSS: ${filePath}`);
    });
}

/**
 * Will link a CSS file via the filePath href value
 * @param {String} filePath - to link
 * @param {String} [name] - style tag's id value
 */
export function linkNonCriticalCSS(filePath, name) {
  const link = document.createElement("link");
  const ref = window.document.getElementsByTagName("head")[0];
  link.id = name || `tgam-non-critical-css-${counter++}`;
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = filePath; // no cache token
  ref.appendChild(link);
}
